import { getElement } from '../Utility/Dom'
import { IS_ACTIVE } from '../Utility/State'

class CursorBurstAnimationService {
  private readonly boundHandleMediaChange = this.handleMediaChange.bind(this)
  private readonly boundHandleMouseDown = this.handleMouseDown.bind(this)
  private readonly boundHandleTransitionEnd = this.handleTransitionEnd.bind(this)
  private readonly cursor: HTMLElement | null
  private mediaQuery: MediaQueryList
  private prefersReducedMotion: boolean

  constructor() {
    this.cursor = getElement('cursor')
    this.mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.prefersReducedMotion = this.mediaQuery.matches
  }

  public destroy(): void {
    if (this.cursor) {
      this.cursor.removeEventListener('transitionend', this.boundHandleTransitionEnd)
    }

    document.documentElement.removeEventListener('mousedown', this.boundHandleMouseDown)
    this.mediaQuery.removeEventListener('change', this.boundHandleMediaChange)
  }

  public init(): void {
    if (this.cursor === null) return

    this.addEvents()
  }

  private addEvents(): void {
    this.mediaQuery.addEventListener('change', this.boundHandleMediaChange)
    document.documentElement.addEventListener('mousedown', this.boundHandleMouseDown)
    this.cursor.addEventListener('transitionend', this.boundHandleTransitionEnd)
  }

  private handleMediaChange(e: MediaQueryListEvent): void {
    this.prefersReducedMotion = e.matches
  }

  private handleMouseDown(e: MouseEvent): void {
    if (this.prefersReducedMotion || !this.cursor) return

    this.cursor.classList.add(IS_ACTIVE)
    this.cursor.style.left = `${e.pageX}px`
    this.cursor.style.top = `${e.pageY}px`
  }

  private handleTransitionEnd(): void {
    this.cursor?.classList.remove(IS_ACTIVE)
  }
}

export default CursorBurstAnimationService
